import { render, staticRenderFns } from "./boardInfo.vue?vue&type=template&id=525d18d7&"
import script from "./boardInfo.vue?vue&type=script&lang=js&"
export * from "./boardInfo.vue?vue&type=script&lang=js&"
import style0 from "./boardInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports